<template>
  <div class="body">
    <!-- common -->
    <div class="common-page dark-theme">
      <div class="wrap">
        <a href="/index.html">
          <h1 class="logo"><img src="../assets/images/common/ci-wavve.png" alt="wavve"/></h1>
        </a>
      </div>
      <div class="error-page">
        <img src="../assets/images/common/icon-error-74.png" alt="error"/>
        <p class="error-txt01">
          서비스 이용에 불편을 드려 죄송합니다.
        </p>
        <p class="error-txt02">
          찾으시는 페이지가 없거나 오류가 발생하였습니다.<br/>
          입력하신 주소가 정확한지 다시한번 확인해 주세요.
          <span>관련 문의사항은 고객센터 1599-3709로 문의하시면 친절하게 안내해드리겠습니다.</span>
        </p>
        <div class="btn-purple">
          <a href="/index.html">
            홈으로 가기
          </a>
        </div>
      </div>
    </div>
    <!--// common -->
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/base.css"></style>
<style lang="css" src="@/assets/css/main.css"></style>
